import React from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';

const LoadingOverlay = ({ message }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress color="primary" />
        <Typography variant="h6" color="white" sx={{ mt: 2 }}>
          {message || 'Loading...'}
        </Typography>
      </Box>
    </Box>
  );
};

export default LoadingOverlay;
